import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=3048c14e"
import script from "./MediaBlock.vue?vue&type=script&lang=js"
export * from "./MediaBlock.vue?vue&type=script&lang=js"
import style0 from "./MediaBlock.vue?vue&type=style&index=0&id=3048c14e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports